import { z } from 'zod'
import {
  AlignmentEnum,
  ContentfulBadgeSchema,
  ContentfulCard,
  ContentfulCardSchema,
  ContentfulCtaSchema,
} from './components'
import { ContentfulRichTextDocumentSchema } from './common'

export const ContentfulCardStyleSchema = z.enum(['tall', 'short', 'imageOverlay'])
export type ContentfulCardStyle = z.infer<typeof ContentfulCardStyleSchema>

export const ContentfulPageSectionSchema = z.object({
  identifier: z.string(),
  heading: z.string(),
  contentAlignment: AlignmentEnum.optional(),
  /** NOTE: comes from contentful as markdown but we transform to rich text for consistency */
  description: ContentfulRichTextDocumentSchema.optional(),
  cards: z
    .array(ContentfulCardSchema.nullable())
    .transform((arr) => arr.filter((item): item is ContentfulCard => item !== null))
    .optional(),
  cardsVariant: z.enum(['default', 'destination', 'inline', 'icons', 'carousel']).optional(),
  cardStyle: ContentfulCardStyleSchema.optional(),
  tallCardVariant: z.boolean().optional(),
  cta: ContentfulCtaSchema.optional(),
  badge: ContentfulBadgeSchema.optional(),
  entryId: z.string().optional(),
  revisionId: z.number().optional(),
  contentType: z.literal('componentPageSection'),
})

export type ContentfulPageSection = z.infer<typeof ContentfulPageSectionSchema>
